//imports
import {
    UNITTYPE_DELETE_OPEN_MODAL,
    UNITTYPE_DELETE_REQUEST,
    UNITTYPE_DELETE_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    unitType: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case UNITTYPE_DELETE_OPEN_MODAL:
            return { ...state, openModal: true, unitType: action.payload }

        case UNITTYPE_DELETE_REQUEST:
            return { ...state, loading: true }

        case UNITTYPE_DELETE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "DELETE_UNITTYPES"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
